import { CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './authentication.service';

@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(private router: Router, private auth: AuthService) { }
  /**
  * Name: canActivate
  * purpose: To check route auth status
  */
  canActivate(next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
    let url: string = state.url;
    const userRoles = localStorage.getItem('userRoles');
    const uamAccess = localStorage.getItem('uamAccess');
    if (!this.auth.isAuthenticated()) {
      this.router.navigate(['login']);
      return false;
    } else if (userRoles == 'CRE') {
      if (uamAccess) {
        return true;
      } else if (url != "/uam") {
        return true;
      } else {
        this.router.navigate(['calling']);
        return false;
      }
    } else if(url == '/market-reporting'){
      return true;
    }  else if(url == '/prs-dashboard'){
      return true;
    }
    else if(url == '/doorstep-dashboard'){
      return true;
    }
     else if(url == '/soft-calling' || url == '/soft-reporting' || url == '/soft-customer360'){
      return true;
    } else if (uamAccess && url == "/uam") {
      return true;
    } else if (userRoles == "Call Center Agent") {
      if (url == '/prs-calling' || url == '/prs-customer360' || url == '/prs-reporting' || url == '/profile' || url == '/workshop-reassignment') {
        return true;
      } else {
        this.router.navigate(['prs-calling']);
        return false;
      }
    } else if (userRoles == "Team Leader" || userRoles == "Manager") {
      if (url == '/prs-reporting' || url == '/profile') {
        return true;
      } else {
        this.router.navigate(['prs-reporting']);
        return false;
      }
    } else if (userRoles == "Vecv SRM User") {
      if (url == '/cdm-calling' || url == '/profile') {
        return true;
      } else {
        this.router.navigate(['cdm-calling']);
        return false;
      }
    } else if (userRoles == "SME") {
      if (url == '/lost-customer' || url == '/lost-customer360' || url == '/reporting' || url=='/doorstep-calling-list' || url=='/doorstep-customer360' || url=='/doorstep-dashboard') {
        return true;
      } else {
        this.router.navigate(['lost-customer']);
        return false;
      }
    }
    else if (userRoles == "Workshop Manager") {
      if (url == '/workshop-manager-calling' || url == '/pipeline-management' || url == '/pipeline-search' || url == '/dashboard') {
        return true;
      } else {
        this.router.navigate(['workshop-manager-calling']);
        return false;
      }
    }
    else if (userRoles == "DSPM") {
      if (url == '/pipeline-management' || url == '/pipeline-search' || url == '/soft-calling' || url == '/soft-reporting' || url == '/soft-customer360') {
        return true;
      }else {
        this.router.navigate(['soft-calling']);
        return false;
      }
    }
    else if (url == '/reporting' || url == '/dashboard' || url == '/profile' || url == '/cdm-calling' || url == '/cdm-customer360') {
      return true;
    } else if (url == '/prs-reporting') {
      return true;
    } else if (url == '/inboundCall') {
      return true;
    } else if(url == '/pipeline-management' || url == '/pipeline-search'){
       return true;
    } else {

      if (userRoles =='Pan India' ) {
        return true;
      }
        this.router.navigate(['dashboard']);
        return false;
      }
  }
}
